import { useMutation, useQuery, useQueryClient } from 'react-query';
import { useAccessToken } from 'utils/auth';
import { fetchWeek, updateWeekStatus } from './api';

export const useWeekDetailsQuery = (
  token: string | undefined,
  cw: number | undefined,
  year: number | undefined
) =>
  useQuery(['weekDetails', token, cw, year], () => fetchWeek(token, cw, year), {
    enabled: !!(token && cw && year)
  });

export const useWeekMutation = (weekId: string | undefined) => {
  const { token } = useAccessToken();
  const queryClient = useQueryClient();

  return useMutation(
    ['updateWeekStatus', token, weekId],
    () => updateWeekStatus(token, weekId),
    {
      onSuccess: () => {
        void queryClient.invalidateQueries(['weekDetails']);
        void queryClient.invalidateQueries(['workPeriods']);
      }
    }
  );
};
